type ToastType = 'success' | 'error' | 'info' | 'warn';

interface ToastOptions {
  duration?: number;
  action?: { label: string; href: string };
}

function show(message: string, type: ToastType = 'info', opts: ToastOptions = {}) {
  const { duration = 4000, action } = opts;

  let region = document.getElementById('toast-region');
  if (!region) {
    region = document.createElement('div');
    region.id = 'toast-region';
    region.className = 'toast-region';
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'false');
    document.body.appendChild(region);
  }

  const toast = document.createElement('div');
  toast.className = `toast toast-${type}`;

  if (action) {
    const span = document.createElement('span');
    span.textContent = message + ' ';
    const link = document.createElement('a');
    link.textContent = action.label;
    link.href = action.href;
    link.style.cssText = 'color:inherit;font-weight:600;text-decoration:underline;margin-left:4px';
    toast.appendChild(span);
    toast.appendChild(link);
  } else {
    toast.textContent = message;
  }

  region.appendChild(toast);

  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transition = 'opacity 0.3s';
    setTimeout(() => toast.remove(), 300);
  }, action ? 8000 : duration);  // longer duration when there's a CTA
}

export const toast = {
  success: (msg: string, opts?: ToastOptions) => show(msg, 'success', opts),
  error:   (msg: string, opts?: ToastOptions) => show(msg, 'error', opts),
  info:    (msg: string, opts?: ToastOptions) => show(msg, 'info', opts),
  warn:    (msg: string, opts?: ToastOptions) => show(msg, 'warn', opts),
};
